function calculateEndingYearMonth(beginningYearMonth: Date) {
  const endingYearMonth = new Date(beginningYearMonth);
  endingYearMonth.setMonth(endingYearMonth.getMonth() + 11);
  return endingYearMonth;
}

export { calculateEndingYearMonth };
